import React, { useEffect } from 'react';
import { Divider, MainButton } from '@icarros/ids-react';
import { useAdContext } from '../../../store/contexts/ad';
import { OpenEditActionsWrapper } from './style';

interface SaveFormContentProps {
  loading: boolean;
  handleClick: () => void;
  isDisabled: boolean;
  isBody?: boolean;
}

export function SaveFormContent({
  loading,
  handleClick,
  isDisabled,
  isBody
}: SaveFormContentProps): JSX.Element {
  const { submitOnModalClick, setSubmitOnModalClick } = useAdContext();

  useEffect(() => {
    if (submitOnModalClick) {
      handleClick();
      setSubmitOnModalClick(false);
    }
  }, [submitOnModalClick, handleClick, setSubmitOnModalClick]);

  return (
    <OpenEditActionsWrapper isBody={isBody}>
      {!isBody && <Divider contrast="default" variant="neutral" weight="light" size="soft" />}
      <MainButton
        isLoading={loading}
        text="salvar alterações"
        isDisabled={isDisabled}
        onClick={handleClick}
      />
    </OpenEditActionsWrapper>
  );
}
